<template>
  <div id="app" style="width: 100%;height: 100%;">
    <reservation-page></reservation-page>
    <Loading v-if="$store.state.showLoading" style="position: fixed;top: 45%;left: 50%;"/>
    <Toast v-if="$store.state.showToast"/>
  </div>
</template>

<script>

import Loading from "@/Loading.vue";
import Toast from "@/Toast.vue";
import utils from './utils';
import { request } from './network/request';
import getRequestParams from "./signParams";
import ReservationPage from './views/ReservationPage.vue'

export default {
  name: 'App',
  data () {
     return {
      
     }
   },
  components:{
    Loading,Toast,ReservationPage
  },
  created:function(){ 
    // // 获取url中的param=后面的参数值，在这里携带的是{"key":"value"}的json形式
    // let params = utils.getUrlKey("param")
    // // 将获取到的参数更新到store中，方面后续获取公共参数
    // this.$store.commit('updateCommonParams', params)
    
    // 从store获取公共参数,这些参数是在一开始就获取到的
    // let storeCommomParams = this.$store.state.commonParameters;
    // // 使用公共参数转换成用于请求api需要的参数值形式
    // let signParams = getRequestParams({},storeCommomParams);
    // 先去获取rid，phone，更新到基本参数中去，再去请求红包初始化，红包用户信息
    // request({
    //   url:this.urls.REBATE_INFO,
    //   params: {
    //     data: signParams // 在url后面加上&data=[signParams具体内容]
    //   },
    // }).then(res =>{
   
    // })
      
  }, 
  methods:{
   
  }
}
</script>

<style>
  body{
    padding-top: 0%;
    margin: 0%;
  }
  input{
    outline: none;
  }
  input::-webkit-input-placeholder {
  color: #B5B5B5;
  }

  input::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #B5B5B5;
  }

  input:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #B5B5B5;
  }

  input:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #B5B5B5;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue